import buildComponent from './utils/build-component';
import imagesloaded  from 'imagesloaded';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initState: {
    isLoaded: false,
    src: null
  },
  initFunction: ($el, params) => {
    
    //
    // Methods
    //

    function onLoad() {
      if ($el.naturalWidth && $el.naturalHeight) {
        params.setState({ isLoaded: true });
      }
    }

    function setSrc() {
      if (!$el.src && $el.dataset.blockImgLoad) {
        params.setState({ src: $el.dataset.blockImgLoad });
      }
      imagesloaded($el, onLoad)
    }

    //
    // Life Cycle
    //

    params.onStateUpdate((newState, prevState) => {
      if (!prevState.src && newState.src) {
        $el.src = newState.src;
      }
    });

    //
    // Procedures
    //

    if (
      (!$el.complete && $el.dataset.blockImgLoad === 'false') || // When image can not be downloaded from internet
      ($el.complete && !$el.dataset.blockImgLoad) // Images inside AJAX loaded pages
    ) {
      $el.dataset.blockImgLoad = $el.src;
      $el.removeAttribute('src');
    } else {
      params.setState({ src: $el.src });
    }

    //
    // Listeners / Observers
    //

    //
    // Public API
    //

    return {
      setSrc,
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/block-img-load.js